export default __webpack_public_path__ + "static/media/3x2.d88862d1.svg";